/**
 * Alpine.js component to toggle high contrast mode.
 * @returns {Object}
 */
export const contrastToggler = () => ({
	/**
	 * Toggle high contrast mode and save preference to localStorage.
	 * @returns {void}
	 */
	toggle() {
		this.$store.contrast.isEnabled = !this.$store.contrast.isEnabled;

		if (this.$store.contrast.isEnabled) {
			document.body.classList.add("contrast");
		} else {
			document.body.classList.remove("contrast");
		}

		localStorage.setItem("contrast", this.$store.contrast.isEnabled);
	},
});

/**
 * Alpine.js store to manage high contrast mode state.
 * @type {Object}
 */
export const contrast = {
	/**
	 * Indicates if high contrast mode is enabled.
	 * @type {boolean}
	 */
	isEnabled: false,

	/**
	 * Initialize the store by checking localStorage for saved preference and applying it.
	 * @returns {void}
	 */
	init() {
		const contrast = localStorage.getItem("contrast");

		if (contrast === "true") {
			document.body.classList.add("contrast");
			this.isEnabled = true;
		}
	},
};
